import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthState } from 'src/app/core/states/auth.state';
import { Store } from '@ngxs/store';
import { CoreModule } from '../core.module';

@Injectable({
  providedIn: CoreModule,
})
export class AuthGuard {
  constructor(
    private router: Router,
    private store: Store
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot) {
    const isAuthenticated = this.store.selectSnapshot(AuthState.isAuthenticated);
    if (isAuthenticated === true) {
      return true;
    }
    return this.router.parseUrl(`/auth/inloggen?redirectTo=${routerState.url}`);
  }
}
